module.exports = __webpack_public_path__ + "img/4 - 3 - 3.91ad2b56.jpg";